module.exports = __webpack_public_path__ + "static/media/aspirinQuestion.9365a05d.mp3";